export default __webpack_public_path__ + "static/media/bookeAiStatusQuickBooks.73e7478b.png";